export default (state, action) => {
  const newState = {...state};
  const query = action.payload;

  // remove all old state associated with search box
  delete newState.q;

  // add updated search to state
  if (query) {
    newState.q = query;
  }

  return newState;
};
